import { useEffect, useState } from 'react';

import {
  ChunkLoadErrorService,
  ChunkRecoveryResult,
} from '../service/ChunkLoadErrorService';

/**
 * ChunkLoadError류 에러를 감지해 1회 자동 새로고침으로 복구를 시도하는 공통 훅.
 * 인앱 웹뷰의 일시적 청크 로드 실패를 "서비스 오류" 화면 노출 없이 회복하기 위해
 * 에러 바운더리(ErrorBoundaryPage, global-error)에서 재사용한다.
 *
 * @returns isChunkLoadError - 청크 로드 실패 여부 (호출부의 로깅 분기에 사용)
 * @returns isRecovering - 자동 복구 진행 중이라 에러 화면을 숨겨야 하면 true
 */
const useChunkLoadErrorRecovery = (error: Pick<Error, 'name' | 'message'>) => {
  const [isRecoveryExhausted, setIsRecoveryExhausted] = useState(false);

  const isChunkLoadError = ChunkLoadErrorService.isChunkLoadError(error);

  useEffect(() => {
    if (!isChunkLoadError) return;

    const recoveryResult = ChunkLoadErrorService.recoverFromError(error);
    if (recoveryResult === ChunkRecoveryResult.EXHAUSTED) {
      setIsRecoveryExhausted(true);
    }
  }, [error, isChunkLoadError]);

  return {
    isChunkLoadError,
    isRecovering: isChunkLoadError && !isRecoveryExhausted,
  };
};

export default useChunkLoadErrorRecovery;
